import createReducer from './createReducer';

const initialState = {
  currenciesSlug: [],
  citiesList: [],
};

const routerAdditionalData = createReducer(initialState, {});

export default routerAdditionalData;
